import { ReviewsSearchStort } from "@/types/service/reviews/reviews.api";

export const REVIEWS_RANGE = 5;
export const PAGE_SIZE = 5;

export const ReviewsSearchSortToSortStringMap: Record<
    ReviewsSearchStort,
    string
> = {
    [ReviewsSearchStort.MOST_RELEVANT]: "relevancy:a1",
    [ReviewsSearchStort.MOST_HELPFUL]:
        "helpfulness:desc,totalpositivefeedbackcount:desc",
    [ReviewsSearchStort.SCORE_DESC]: "rating:desc",
    [ReviewsSearchStort.SCORE_ASC]: "rating:asc",
    [ReviewsSearchStort.MOST_RECENT]: "submissiontime:desc"
};
